
<template>

  <body>
    <!--头部-->
    <div id="header">
      <div class="header-inner">
        <h1><a href="index.html"><img width="382" height="56" src="../../static/images/logo.png" alt="小白保险logo" title="小白保险"/></a></h1>
        <a id="zysq-introduce" href="http://mp.weixin.qq.com/s?__biz=MzAxNzA5Mjc5Ng==&mid=201323575&idx=1&sn=619210f13033538428fa23ae023508e8&scene=1#rd" target="_blank">展业神器简介</a>
      </div>
    </div>
    <div class="clearfix"></div><!--ie7兼容-->
    <!--内容-->
    <div id="content"  style="margin-top: 260px;">
      <div id="about-content" class="clearfix">
        <h2 class="download-tit">根据您的手机，选择下载</h2>
        <ul class="downlaod-wrap clearfix">
          <li class="ios-li" style="cursor: pointer;"  @click="ios()"><div class="iphone-logo" ></div></li>
          <li class="android-li" style="cursor: pointer;" @click="android()"><div class="android-logo" /></li>
          <li class="ewm-li"><div class="ewm-logo"/></li>
        </ul>
      </div>
    </div>
    <!--
      尾部
      current为当前状态
    -->
    <div id="footer">
      <ul id="nav">
        <li><a href="http://www.xiaobaibao.com/">首页</a></li>
        <li><a href="/about.html">关于我们</a></li>
        <li class="current"><a href="/download.html">下载客户端</a></li>
        <li><a href="/server_bd.html">服务与帮助</a></li>
        <li><a href="/join.html">加入我们</a></li>
        <li><a href="/contact.html">联系我们</a></li>
      </ul>
      <div class="ban"><a style="color:#b2b2b2" href="http://www.miitbeian.gov.cn/publish/query/indexFirst.action" target="_blank">粤ICP备13035223号-3</a></div>
      <div class="ban-left">广州米兔网络科技有限公司  </div>
    </div>
    <a id="ios" href="https://itunes.apple.com/us/app/xiao-bai-bao-xian/id930504801?mt=8" target="_blank"></a>
  </body>
</template>
<script>
    export default {
        name: "download",
        data() {
            return{
            }
        },
        methods: {
            android(){
                window.open("http://a.app.qq.com/o/simple.jsp?pkgname=com.rightchoice.xiaobai&g_f=991653");
            },
            ios(){
                window.open("https://apps.apple.com/cn/app/%E5%B0%8F%E7%99%BD%E5%AE%9D-%E7%99%BE%E4%B8%87%E7%8B%AC%E7%AB%8B%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E4%BA%BA%E9%83%BD%E5%9C%A8%E4%BD%BF%E7%94%A8/id1041660260");
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
  /*@import "../../static/css/rcMain/download.css";*/
  @import "../../static/css/rcMain/common.css";

  body {
    width: 100%;
    height: 100%;
    zoom: 1;
    position: relative
  }

  .download-tit {
    font-size: 20px;
    color: #000000;
    text-align: center;
    margin-bottom: 60px
  }

  .downlaod-wrap {
    width: 1000px;
  }

  .downlaod-wrap li {
    width: 300px;
    height: 200px;
    float: left;
    position: relative
  }

  .downlaod-wrap .ios-li {
    width: 300px;
    height: 200px;
  }

  .android-li, .ewm-li, .ios-li {
    border: 1px solid #eeeeee
  }

  .android-li {
    margin: 0 47px;
  }

  .iphone-logo, .android-logo, .ewm-logo {
    width: 100px;
    height: 100px;
    margin: 50px 100px;
  }

  .iphone-logo {
    background: url("../../static/images/iphone.png") no-repeat
  }

  .android-logo {
    background: url("../../static/images/android.png") no-repeat
  }

  .downlaod-wrap .ios-li:hover {
    width: 300px;
    height: 200px;
    background-color: #ff6503;
    box-shadow: 5px 9px 20px rgba(0, 0, 0, .4);
    border-bottom: none;
  }

  .downlaod-wrap .android-li:hover {
    width: 300px;
    height: 200px;
    background-color: #ff6503;
    box-shadow: 5px 9px 20px rgba(0, 0, 0, .4);
    border-bottom: none;
  }

  .downlaod-wrap .ios-li:hover .iphone-logo {
    background: url("../../static/images/iphone_hover.png") no-repeat
  }

  .downlaod-wrap .android-li:hover .android-logo {
    background: url("../../static/images/android_hover.png") no-repeat
  }

  .ewm-logo {
    background: url("../../static/images/download.png") no-repeat;
    background-size: 100%;
  }

  #header {
    background-color: #ffffff
  }

  .ie8 #content {
    margin-top: 220px
  }

  .ie6 #content {
    margin-top: 220px
  }

</style>



// WEBPACK FOOTER //
// src/components/download.vue